import * as Sentry from "@sentry/react";
import { getEnv } from "./utils/runtime-config";

Sentry.init({
  dsn: getEnv("SENTRY_DSN") || import.meta.env.SENTRY_DSN || "",
  sendDefaultPii: true,
  replaysOnErrorSampleRate: 1.0,
  environment:
    getEnv("SENTRY_ENV") || import.meta.env.SENTRY_ENV || "development",
});
